// extracted by mini-css-extract-plugin
export default {"container":"footer_container__GZsRq","support":"footer_support__DDw87","listContainer":"footer_listContainer__Y2G36","newsletter":"footer_newsletter__LbzVM"};